'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'okved', 'StatusService', 'OkvedMultiService',
    function ($scope, $modalInstance, okved, StatusService, OkvedService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.okved = angular.copy(okved);

            if (angular.equals(okved, {})) {
                $scope.okved.parent = {};
            }

            if (okved == null || angular.equals({}, okved) || okved.id == null) {
                $scope.title = "Создание нового вида экономической деятельности";
            } else {
                $scope.title = "Редактирование вида экономической деятельности \"" + $scope.okved.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.okved.status) {
                    $scope.okved.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.okved);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                OkvedService.api.isUniqueName({name: name}, {id: $scope.okved.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];